<template>
  <c-container>
    <c-car-filters :filters="filters" :enableCar24Flg="enableCar24Flg" :orgcode="orgcode" />

    <v-layout class="justify-end pa-4">
      <v-sheet outlined rounded class="pa-4 grey-border">
      <p>
        <span class="legend-line">○ ... 終日予約できます</span>
        <br class="br-disp">
        <span class="legend-line">△ ... 予約可能な時間があります</span>
        <br class="br-disp">
        <span class="legend-line">－ ... 既に予約されています</span>
        <br class="br-disp">
        <br>
        <span class="legend-line">青 ... キャンペーン期間</span>
        <br class="br-disp">
        <span class="legend-line">黄色 ... ハイシーズン期間</span>
      </p>
      </v-sheet>
    </v-layout>

    <template v-if="showCars.length > 0">
      <c-car
        v-for="car in showCars"
        :key="car.id"
        :stationID="stationID"
        :car="car"
        :dates="dates"
        :calendar="calendar"
      />
    </template>

    <v-sheet v-else class="pa-4">
      <p>該当する車両は見つかりません。</p>
    </v-sheet>
  </c-container>
</template>

<style scoped>
@media screen and (min-width: 1024px) {
  .br-disp {
    display: none;
  }
}

.grey-border {
  border: 1px solid grey;
}

.legend-line {
  padding-right:20px;
}
</style>

<script>
import page from '@/mixins/page'
import CCarFilters from '@/components/CCarFilters'
import CCar from './CCar'
import * as CCalendar from '@/components/CCalendar'
import SyncHScroll from './SyncHScroll'

import * as api from '@/api'
import * as http from '@/libs/http'

export default {
  name: 'Availability',
  mixins: [
    page('空き状況'),
    SyncHScroll.Host
  ],
  components: {
    CCarFilters,
    CCar
  },

  async prepare (to) {
    // ステーションIDを to から取得する
    const stationID = to.params.stid - 0
    const shopID = (stationID / 100) | 0
    const orgcode = to.params.orgcode

    const results = await Promise.all([
      // 車両一覧を取得する
      api.getShopCars(shopID, [
        'maker',
        'name',

        'classID',
        'className',
        'chargeText',

        'category',
        'categoryName',
        'type',
        'typeName',

        'image',
        'attributes',
        'hasDetails'
      ]),

      // カレンダーを取得する
      api.getShopCalendar(shopID)
    ])
    const cars = (results[0].status === http.OK) ? results[0].data : []
    const calendar = results[1].data

    // 表示する最長期間を得る
    const allow = calendar.allow

    // 各車両の空き状況を取得する
    const resp = await api.getAvailableDays(shopID, allow.begin, allow.end)
    const availables = resp.data

    // CCalendar 用のカレンダー情報を作成する
    const cal = CCalendar.createCalendar(calendar)

    // 各車両毎に CCalendar 用の各日付の状態を作成する
    for (const car of cars) {
      const spans = availables[car.id] || []
      car.states = CCalendar.createStates(cal.dates, spans)
    }

    // 24時間対応車両が存在するか？
    let enableCar24Flg = false
    const keykey = cars.filter(carw => carw.attributes.keykey === 1)
    const vkey = cars.filter(carw => carw.attributes.vkey === 1)
    if (keykey.length > 0 || vkey.length > 0) {
      enableCar24Flg = true
    }

    return {
      orgcode,
      stationID,
      dates: cal.dates,
      calendar: cal.calendar,
      cars,
      enableCar24Flg
    }
  },

  props: {
    orgcode: String,
    stationID: Number,
    dates: Array,
    calendar: Object,
    cars: Array,
    enableCar24Flg: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    filters: {
      carType: '',
      car24Flg: ''
    }
  }),

  computed: {
    showCars () {
      const filters = this.filters
      let cars = this.cars

      if (filters.carType) {
        cars = cars.filter(car => car.type === filters.carType)
      }

      if (filters.car24Flg) {
        cars = cars.filter(car => {
          if (car.attributes.keykey === 1 || car.attributes.vkey === 1) {
            return true
          }
        })
      }

      return cars
    }
  }
}
</script>
